export const capitalizeFirstLetter = (str: string) => {
  // Converting first letter to uppercase
  const capitalized = str.charAt(0).toUpperCase() + str.slice(1);

  return capitalized;
};
